import { render, staticRenderFns } from "./ToTop.vue?vue&type=template&id=72286b7c&scoped=true&"
import script from "./ToTop.vue?vue&type=script&lang=js&"
export * from "./ToTop.vue?vue&type=script&lang=js&"
import style0 from "./ToTop.vue?vue&type=style&index=0&id=72286b7c&prod&lang=scss&scoped=true&"
import style1 from "./ToTop.vue?vue&type=style&index=1&id=72286b7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72286b7c",
  null
  
)

export default component.exports